import { render, staticRenderFns } from "./Inscriptions-final-component.vue?vue&type=template&id=177fd23a&scoped=true&"
import script from "./Inscriptions-final-component.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-final-component.vue?vue&type=script&lang=js&"
import style0 from "./Inscriptions-final-component.vue?vue&type=style&index=0&id=177fd23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177fd23a",
  null
  
)

export default component.exports